import ReactGA from "react-ga4";
import AnalyticsAdapter from "../core/AnalyticsAdapter";

/**
 * Concrete GA4 destination. Thin wrapper around react-ga4 (gtag.js) — no
 * business logic lives here beyond translating the AnalyticsAdapter contract
 * into GA4's API shape.
 */
export default class GA4Adapter extends AnalyticsAdapter {
  /** @param {{ measurementId: string, debug?: boolean }} options */
  constructor({ measurementId, debug = false }) {
    super();
    this.measurementId = measurementId;
    this.debug = debug;
    this.initialized = false;
  }

  initialize() {
    if (this.initialized || !this.measurementId) return;
    ReactGA.initialize(this.measurementId, { gaOptions: { debug_mode: this.debug } });
    this.initialized = true;
  }

  trackPageView(path, title) {
    if (!this.initialized) return;
    ReactGA.send({ hitType: "pageview", page: path, title });
  }

  trackEvent(name, params = {}) {
    if (!this.initialized) return;
    ReactGA.event(name, params);
  }

  setUser(userId) {
    if (!this.initialized) return;
    ReactGA.set({ userId: userId || undefined });
  }

  setUserProperties(properties = {}) {
    if (!this.initialized) return;
    ReactGA.set(properties);
  }
}
